__turbopack_context__.v({
  "button": "SuccessModal-module__Gl0GQW__button",
  "buttons": "SuccessModal-module__Gl0GQW__buttons",
  "description": "SuccessModal-module__Gl0GQW__description",
  "discord": "SuccessModal-module__Gl0GQW__discord",
  "discordIcon": "SuccessModal-module__Gl0GQW__discordIcon",
  "icon": "SuccessModal-module__Gl0GQW__icon",
  "root": "SuccessModal-module__Gl0GQW__root",
  "title": "SuccessModal-module__Gl0GQW__title",
  "twitterIcon": "SuccessModal-module__Gl0GQW__twitterIcon",
});
